import React from 'react'
import { Link } from 'react-router-dom'
import { Space, Typography } from 'antd'
import { isNil, map } from 'lodash'
import PropTypes from 'prop-types'

const TermErrors = ({ errors }) =>
  map(errors, ({ term, ingredient: duplicateIngredient, type }, index) => (
    <Typography.Paragraph key={index}>
      <Space>
        <Typography.Text type="danger" strong>
          {term}
        </Typography.Text>
        {!isNil(duplicateIngredient) && (
          <>
            <Typography.Text type="danger">conflicts with:</Typography.Text>

            <Link to={`/ingredients/${duplicateIngredient.id}`}>
              {duplicateIngredient.name}
            </Link>
          </>
        )}
        {!isNil(type) && (
          <Typography.Text type="danger">found in {type}</Typography.Text>
        )}
        {isNil(type) && isNil(duplicateIngredient) && (
          <Typography.Text type="danger">duplicated</Typography.Text>
        )}
      </Space>
    </Typography.Paragraph>
  ))

TermErrors.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default TermErrors
